/**
 * Base URL of the BiorAdmin backend that receives the visit ping
 * (/api/track-visit) and the public forms (/api/integrate).
 *
 * The value comes from the environment only. There is no built-in default:
 * the backend host is deployment specific and a baked-in fallback silently
 * outlives the deployment it pointed at.
 *
 *   REACT_APP_VISITOR_API_BASE_URL=https://<admin-backend-host>
 *
 * Create React App inlines REACT_APP_* variables at build time, so the value
 * must be present in the environment of `npm start` and `npm run build`.
 * `npm run build` refuses to run without it (see scripts/check-env.js).
 */
export const API_BASE_ENV = "REACT_APP_VISITOR_API_BASE_URL";

export function getApiBase() {
  // CRA only inlines the variable when it is referenced by its full name.
  const raw = (process.env.REACT_APP_VISITOR_API_BASE_URL || "").trim();

  if (!raw) {
    const message =
      `${API_BASE_ENV} is not set. Visit tracking and the public forms have no ` +
      "backend to talk to. Set it in .env.local (see .env.example) and restart.";
    if (process.env.NODE_ENV === "development") {
      throw new Error(message);
    }
    // eslint-disable-next-line no-console
    console.error(message);
    return "";
  }

  return raw.replace(/\/+$/, "");
}
